import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withComponentId } from '../../../common/ComponentIdContext';
import withMarketPreOpen from '../../../common/market-pre-open/withMarketPreOpen';
import SearchBoxWithData from '../../../common/search-box-with-data/SearchBoxWithData';
import { formatTextFloat, formatValue } from '../../../helpers/Text';
import BuySellTreeMap from '../common/buy-sell-tree-map/BuySellTreeMap';
import Tooltip from '../common/buy-sell-tree-map/Tooltip';
import Const from '../Const';
import {
  changeForeignCurrentSearch,
  fetchForeign,
  REDUCER_NAME,
} from '../reducer';
import withRealTime from '../withRealTime';
import ChartWrap from './ChartWrap';
import Footer from './../../../common/table/Footer';
import Loading from '../../../common/loading/Loading';

const TREE_MAP_HEIGHT = 400;

const calcNet = data => data.foreignBuyValue - data.foreignSellValue;

const renderBuyTooltip = (data, textClassName, currentType) => {
  if (currentType === 'NET_VALUE') {
    return (
      <Tooltip
        data={data}
        textClassName={textClassName}
        secondTitle="moneyFlowForeign.foreignBuyNetTitle"
        secondValue={Math.abs(data.foreignNetBuyValue)}
      />
    );
  }

  return (
    <Tooltip
      data={data}
      textClassName={textClassName}
      secondTitle="moneyFlowForeign.tooltipBuyTitle"
      thirdTitle="moneyFlowForeign.tooltipBuyNetTitle"
      secondValue={data.foreignBuyValue}
      thirdValue={formatTextFloat(formatValue(calcNet(data)))}
    />
  );
};

const renderSellTooltip = (data, textClassName, currentType) => {
  if (currentType === 'NET_VALUE') {
    return (
      <Tooltip
        data={data}
        textClassName={textClassName}
        secondTitle="moneyFlowForeign.foreignSellNetTitle"
        secondValue={Math.abs(data.foreignNetSellValue)}
      />
    );
  }

  return (
    <Tooltip
      data={data}
      textClassName={textClassName}
      secondTitle="moneyFlowForeign.tooltipSellTitle"
      thirdTitle="moneyFlowForeign.tooltipSellNetTitle"
      secondValue={data.foreignSellValue}
      thirdValue={formatTextFloat(formatValue(calcNet(data)))}
    />
  );
};

const Foreign = ({
  foreign,
  isLoading,
  changeForeignCurrentSearch,
  currentSearch,
}) => {
  return (
    <div
      className={`foreign-wrapper tab-pane active d-flex flex-fill flex-column`}
    >
      <div className="px-20 mb-10">
        <div className="money-flow-search-box">
          <SearchBoxWithData
            defaultCurrentSearch={currentSearch}
            onChangeCode={changeForeignCurrentSearch}
          />
        </div>
      </div>

      <div className={`d-flex flex-fill flex-column h-100 px-20`}>
        {isLoading && <Loading />}
        <div
          className={`d-flex flex-fill flex-column ${
            isLoading ? 'bg-blur' : ''
          }`}
        >
          <ChartWrap />
          <BuySellTreeMap
            dropdown={{
              ids: Const.foreignDropDown,
              data: Const.foreignDropDownData,
            }}
            isTicker={currentSearch.isTicker}
            isRealtimeTicker={true}
            sellKey="foreignSellValue"
            buyKey="foreignBuyValue"
            netBuyKey="foreignNetBuyValue"
            netSellKey="foreignNetSellValue"
            renderBuyTooltip={renderBuyTooltip}
            renderSellTooltip={renderSellTooltip}
            height={TREE_MAP_HEIGHT}
            data={foreign}
          />
        </div>
        <Footer />
      </div>
    </div>
  );
};

Foreign.propTypes = {
  fetchData: PropTypes.func.isRequired,
  foreign: PropTypes.object.isRequired,
  comGroupCode: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  foreign: state[REDUCER_NAME].foreign.data,
  isLoading: state[REDUCER_NAME].foreign.isLoading,
  comGroupCode: state[REDUCER_NAME].foreign.currentSearch.code,
  currentSearch: state[REDUCER_NAME].foreign.currentSearch,
});

const mapDispatchToProps = {
  fetchData: fetchForeign,
  changeForeignCurrentSearch,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  //withMarketPreOpen('flex-fill'), -- hidden preopen market clock
  withRealTime,
)(Foreign);
